import { joinedKeywordIds } from "./consts";

type Replacer = (...captured: string[]) => string;

export const makeReplacer =
  (regex: RegExp) =>
  (input: string, replacer: Replacer): string =>
    input.replace(regex, (match, ...captured) => replacer(...captured));

export const replaceHighlightableText = makeReplacer(/<mark>(.*?)<\/mark>/g);

export const replaceLatex = makeReplacer(/\$\$(.+?)\$\$/g);

export const replaceKeywords = makeReplacer(
  new RegExp(`(^|[^-\\w])(${joinedKeywordIds})($|[^-\\w])`, "gi")
);

export const replaceNewLine = makeReplacer(/(\n+)/g);

export default class MarkdownReplacer {
  _input: string | undefined;

  constructor(input?: string) {
    input && this.input(input);
  }

  input(input: string) {
    this._input = input;
    return this;
  }

  replaceHighlightableText(replacer: Replacer) {
    this._input = replaceHighlightableText(this._input!, replacer);
    return this;
  }

  replaceLatex(replacer: Replacer) {
    this._input = replaceLatex(this._input!, replacer);
    return this;
  }

  replaceKeywords(replacer: Replacer) {
    this._input = replaceKeywords(this._input!, replacer);
    return this;
  }

  replaceNewLine(replacer: Replacer) {
    this._input = replaceNewLine(this._input!, replacer);
    return this;
  }

  toString() {
    return this._input;
  }
}
